// extracted by mini-css-extract-plugin
export default {"stickyArticleHeader":"m_bt","stickyArticleHeaderContainer":"m_bv","stickyArticleHeaderButton":"m_bw","text_left":"m_bx","progressContainer":"m_by","progressBar":"m_bz"};